
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormState {
    complete: boolean;
}

const initialState: FormState = {
    complete: false,
};

const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        markComplete(state) {
            state.complete = true;
        },
        markIncomplete(state) {
            state.complete = false;
        },
        resetComponent(state) {
            state.complete = false; 
        },
    },
});

export const { markComplete, markIncomplete, resetComponent } = formSlice.actions;
export default formSlice.reducer;
